module.exports = __webpack_public_path__ + "static/img/cellphone-ela.44fcd53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/cellphone-ela.jpg
// module id = /5OD
// module chunks = 1